import axios from '@/utilities/axios-global'

const GET_CODER_IP_EXISTS = async context => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/coder/inpatient/exists`)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const GET_CODER_PRO_EXISTS = async context => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/coder/pro/exists`)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const GET_CODER_OP_EXISTS = async context => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/coder/outpatient/exists`)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const GET_IP_WORKSHEET = async (context, drgTableId) => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/my-projects/inpatient/worksheet/${drgTableId}`)
    context.commit('SET_IP_WORKSHEET', response.data[0])
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const GET_PRO_WORKSHEET = async (context, proRecordId) => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/my-projects/provider/worksheet/${proRecordId}`)
    context.commit('SET_PRO_WORKSHEET', response.data[0])
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const GET_OP_WORKSHEET = async (context, ascTableId) => {
  try {
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/my-projects/outpatient/worksheet/${ascTableId}`)
    context.commit('SET_OP_WORKSHEET', response.data[0])
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const RUN_IP_MASS_ACKNOWLEDGE_NO_CHANGES = (context, payload) => {
  try {
    const response = axios.put(`${context.rootState.user.baseApiUrl}/coder/inpatient/massacknowledgenochanges`, payload)
    return response
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const RUN_OP_MASS_ACKNOWLEDGE_NO_CHANGES = (context, payload) => {
  try {
    const response = axios.put(`${context.rootState.user.baseApiUrl}/coder/outpatient/massacknowledgenochanges`, payload)
    return response
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const RUN_PRO_MASS_ACKNOWLEDGE_NO_CHANGES = (context, payload) => {
  try {
    const response = axios.put(`${context.rootState.user.baseApiUrl}/coder/pro/massacknowledgenochanges`, payload)
    return response
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const LOAD_PROJECT_LIST = async (context, param) => {
  try {
    context.commit('SET_PROJECT_LIST_LOADING', true)
    // let url = process.env.VUE_APP_API_BASE_URL + '/api/projects/reviews'
    const response = await axios.get(`${context.rootState.user.baseApiUrl}/my-projects/list?startDate=${param.dateRange.startDate}&endDate=${param.dateRange.endDate}`)
    context.commit('SET_PROJECT_LIST_LOADING', false)
    context.commit('SET_PROJECT_LIST', response.data)
    return response.data
  } catch (err) {
    console.log(err)
    context.commit('SET_PROJECT_LIST', [])
    context.commit('SET_PROJECT_LIST_LOADING', false)
    throw new Error(err.response.data.message)
  }
}

const LOAD_PROJECT = async (context, payload) => {
  try {
    context.commit('SET_PROJECTPK', payload.id)
    context.commit('SET_PROJECT_LOADING', true)

    // first fetch the project
    const projectResponse = await axios.get(`${context.rootState.user.baseApiUrl}/my-projects/${payload.id}`)
    const project = projectResponse.data
    // then fetch the IDs and stats for the applicable project type
    // payload.projectTypeName = project.projectTypeName
    // await GET_PROJECT_DASHBOARD_IDS_STATS(context, payload).catch(err => {
    //   console.log(err)
    // })

    context.commit('SET_PROJECT', project)
    context.commit('SET_PROJECT_LOADING', false)
  } catch (err) {
    console.log(err)
    context.commit('SET_PROJECT_LOADING', false)
    throw new Error(err.response.data.message)
  }
}

const LOAD_REBUTTALS_IP_LIST_PAGINATED = async (context, payload) => {
  try {
    const response = await axios.post(`${context.rootState.user.baseApiUrl}/my-projects/inpatient/paginated`, payload)
    context.commit('SET_IP_LIST_STATISTICS', response.data.statistics)
    context.commit('SET_IP_LIST_META', response.data)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const LOAD_REBUTTALS_OP_LIST_PAGINATED = async (context, payload) => {
  try {
    const response = await axios.post(`${context.rootState.user.baseApiUrl}/my-projects/outpatient/paginated?outpatientGrouperId=1`, payload)
    context.commit('SET_OP_LIST_STATISTICS', response.data.statistics)
    context.commit('SET_OP_LIST_META', response.data)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const LOAD_REBUTTALS_AMB_LIST_PAGINATED = async (context, payload) => {
  try {
    const response = await axios.post(`${context.rootState.user.baseApiUrl}/my-projects/outpatient/paginated?outpatientGrouperId=2`, payload)
    context.commit('SET_AMB_LIST_STATISTICS', response.data.statistics)
    context.commit('SET_AMB_LIST_META', response.data)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

const LOAD_REBUTTALS_PRO_LIST_PAGINATED = async (context, payload) => {
  try {
    const response = await axios.post(`${context.rootState.user.baseApiUrl}/my-projects/pro/paginated`, payload)
    context.commit('SET_PRO_LIST_STATISTICS', response.data.statistics)
    context.commit('SET_PRO_LIST_META', response.data)
    return response.data
  } catch (err) {
    console.log(err)
    throw new Error(err.response.data.message)
  }
}

export default {
  GET_IP_WORKSHEET,
  GET_PRO_WORKSHEET,
  GET_CODER_IP_EXISTS,
  GET_CODER_PRO_EXISTS,
  GET_OP_WORKSHEET,
  GET_CODER_OP_EXISTS,
  RUN_IP_MASS_ACKNOWLEDGE_NO_CHANGES,
  RUN_OP_MASS_ACKNOWLEDGE_NO_CHANGES,
  RUN_PRO_MASS_ACKNOWLEDGE_NO_CHANGES,
  LOAD_PROJECT_LIST,
  LOAD_PROJECT,
  LOAD_REBUTTALS_IP_LIST_PAGINATED,
  LOAD_REBUTTALS_OP_LIST_PAGINATED,
  LOAD_REBUTTALS_AMB_LIST_PAGINATED,
  LOAD_REBUTTALS_PRO_LIST_PAGINATED
}
